const tableColumns = [
    {
        name: 'High Priority',
        key: 'highPriority',
        size: 1,
        sortKey: 'highPriority',
        classSize: 'icn',
    },
    { name: '', key: 'icons', size: 2, sortKey: '', classSize: 'icn' },
    { name: 'Expense ID', key: 'expenseId', size: 2, sortKey: 'expenseId', classSize: 'xsm' },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status', classSize: 'med' },
    {
        name: 'Credit Card Account',
        key: 'creditCardNumber',
        size: 2,
        sortKey: 'creditCard',
        classSize: 'med',
    },
    {
        name: 'Clinician',
        key: 'clinicianName',
        size: 2,
        sortKey: 'clinicianLastName',
        classSize: 'lrg',
    },
    { name: 'Booking Number', key: 'bookingId', size: 2, sortKey: 'bookingName', classSize: 'sml' },
    { name: 'Division', key: 'division', size: 2, sortKey: 'division', classSize: 'med' },
    {
        name: 'Submitted Date',
        key: 'submittedDate',
        size: 2,
        sortKey: 'submittedDate',
        classSize: 'sml',
    },
    { name: 'Period End', key: 'periodEndDate', size: 2, sortKey: 'periodEnd', classSize: 'med' },
    { name: 'Post Date', key: 'postDate', size: 2, sortKey: 'postDate', classSize: 'med' },
    { name: 'Submitted Amount', key: 'amount', size: 2, sortKey: 'amount', classSize: 'med' },
    {
        name: 'Reimbursed Amount',
        key: 'reimbursedAmount',
        size: 2,
        sortKey: 'reimbursedAmount',
        classSize: 'med',
    },
    {
        name: 'Transaction Date',
        key: 'transactionDate',
        size: 2,
        sortKey: 'transactionDate',
        classSize: 'med',
    },
    { name: 'Start Date', key: 'startDate', size: 2, sortKey: 'startDate', classSize: 'sml' },
    { name: 'End Date', key: 'endDate', size: 2, sortKey: 'endDate', classSize: 'sml' },
    { name: 'Bill Type', key: 'billType', size: 2, sortKey: 'billType', classSize: 'med' },
    { name: 'Expense Type', key: 'expenseType', size: 2, sortKey: 'expenseType', classSize: 'med' },
    { name: 'Pay Date', key: 'payDate', size: 2, sortKey: 'payDate', classSize: 'med' },
    { name: 'Source', key: 'source', size: 2, sortKey: 'source', classSize: 'med' },
];

const vendorPaymentTableColumns = [
    {
        name: 'High Priority',
        key: 'highPriority',
        size: 1,
        sortKey: 'highPriority',
        classSize: 'icn',
    },
    { name: '', key: 'icons', size: 2, sortKey: '', classSize: 'icn' },
    { name: 'Expense ID', key: 'expenseId', size: 2, sortKey: 'expenseId', classSize: 'xsm' },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status', classSize: 'med' },
    {
        name: 'Clinician Name',
        key: 'clinicianName',
        size: 2,
        sortKey: 'clinicianLastName',
        classSize: 'lrg',
    },
    {
        name: 'Pay To The Order of',
        key: 'payToOrderOf',
        sortKey: 'payToOrderOf',
        size: 2,
        classSize: 'lrg',
    },
    {
        name: 'Vendor Name',
        key: 'supplierName',
        size: 2,
        sortKey: 'supplierName',
        classSize: 'lrg',
    },
    { name: 'Amount', key: 'amount', size: 1, sortKey: 'amount', classSize: 'xsm' },
    { name: 'Expense Type', key: 'expenseType', size: 2, sortKey: 'expenseType', classSize: 'med' },
    {
        name: 'Expense Category',
        key: 'expenseCategory',
        size: 2,
        sortKey: 'expenseCategory',
        classSize: 'med',
    },
    { name: 'Booking #', key: 'bookingId', size: 2, sortKey: 'bookingName', classSize: 'sml' },
    {
        name: 'State',
        key: 'state',
        size: 2,
        sortKey: 'state',
        classSize: 'xsm',
    },
    { name: 'Clinician ID', key: 'clinicianId', size: 2, sortKey: 'clinicianId', classSize: 'sml' },
    { name: 'Start Date', key: 'startDate', size: 2, sortKey: 'startDate', classSize: 'sml' },
    { name: 'End Date', key: 'endDate', size: 2, sortKey: 'endDate', classSize: 'sml' },
    { name: 'Billing Type', key: 'billType', size: 2, sortKey: 'billType', classSize: 'med' },
    { name: 'Receipt', key: 'hasReceipts', size: 2, sortKey: '', classSize: 'sml' },
    { name: 'Division', key: 'division', size: 2, sortKey: 'division', classSize: 'med' },
    {
        name: 'Submitted Date',
        key: 'submittedDate',
        size: 2,
        sortKey: 'submittedDate',
        classSize: 'sml',
    },
    { name: 'Processed Date', key: 'payDate', size: 2, sortKey: 'payDate', classSize: 'sml' },
];

const vaultChargesTableColumns = [
    {
        name: 'High Priority',
        key: 'highPriority',
        size: 1,
        sortKey: 'highPriority',
        classSize: 'icn',
    },
    { name: 'Expense ID', key: 'expenseId', size: 2, sortKey: 'id', classSize: 'xsm' },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status', classSize: 'med' },
    { name: 'Receipt', key: 'vaultPdfExpenseImageId', size: 1, sortKey: '', classSize: 'xsm' },
    {
        name: 'Clinician Name',
        key: 'clinicianName',
        size: 2,
        sortKey: 'clinicianLastName',
        classSize: 'lrg',
    },
    { name: 'Amount', key: 'totalAmount', size: 1, sortKey: 'amount', classSize: 'xsm' },
    { name: 'Division', key: 'division', size: 2, sortKey: 'division', classSize: 'med' },
    { name: 'Expense Type', key: 'expenseType', size: 2, sortKey: 'expenseType', classSize: 'med' },
    { name: 'Invoice #', key: 'invoice', size: 2, sortKey: 'invoice', classSize: 'sml' },
    { name: 'Bill Type', key: 'billType', size: 2, sortKey: 'billType', classSize: 'med' },
    { name: 'Import Date', key: 'created', size: 2, sortKey: 'created', classSize: 'sml' },
];

const creditCardTableColumns = [
    { name: '', key: 'icons', size: 2, sortKey: '', classSize: 'icn' },
    { name: 'Expense ID', key: 'expenseId', size: 2, sortKey: 'expenseId', classSize: 'xsm' },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status', classSize: 'med' },
    {
        name: 'Credit Card Account',
        key: 'creditCardNumber',
        size: 2,
        sortKey: 'creditCard',
        classSize: 'lrg',
    },
    {
        name: 'Clinician',
        key: 'clinicianName',
        size: 2,
        sortKey: 'clinicianLastName',
        classSize: 'med',
    },
    { name: 'Booking Number', key: 'bookingId', size: 2, sortKey: 'bookingName', classSize: 'med' },
    {
        name: 'Transaction Date',
        key: 'transactionDate',
        size: 2,
        sortKey: 'transactionDate',
        classSize: 'med',
    },
    {
        name: 'Merchant Name',
        key: 'merchantName',
        size: 2,
        sortKey: 'merchantName',
        classSize: 'med',
    },
    { name: 'Amount', key: 'amount', size: 2, sortKey: 'amount', classSize: 'med' },
    { name: 'Start Date', key: 'startDate', size: 2, sortKey: 'startDate', classSize: 'med' },
    { name: 'End Date', key: 'endDate', size: 2, sortKey: 'endDate', classSize: 'med' },
    { name: 'Bill Type', key: 'billType', size: 2, sortKey: 'billType', classSize: 'med' },
    { name: 'Expense Type', key: 'type', size: 2, sortKey: 'type', classSize: 'med' },
    { name: 'Division', key: 'division', size: 2, sortKey: 'division', classSize: 'med' },
];

const pendingCCTableColumns = [
    { name: 'Expense ID', key: 'expenseId', size: 2, sortKey: 'expenseId', classSize: 'med' },
    { name: 'Status', key: 'status', size: 2, sortKey: 'status', classSize: 'med' },
    {
        name: 'Credit Card Account',
        key: 'creditCardNumber',
        size: 2,
        sortKey: 'creditCard',
        classSize: 'lrg',
    },
    {
        name: 'Clinician',
        key: 'clinicianName',
        size: 2,
        sortKey: 'clinicianLastName',
        classSize: 'med',
    },
    { name: 'Booking Number', key: 'bookingId', size: 2, sortKey: 'bookingName', classSize: 'med' },
    {
        name: 'Transaction Date',
        key: 'transactionDate',
        size: 2,
        sortKey: 'transactionDate',
        classSize: 'med',
    },
    {
        name: 'Merchant Name',
        key: 'merchantName',
        size: 2,
        sortKey: 'merchantName',
        classSize: 'med',
    },
    { name: 'Amount', key: 'amount', size: 2, sortKey: 'amount', classSize: 'med' },
    { name: 'Start Date', key: 'startDate', size: 2, sortKey: 'startDate', classSize: 'med' },
    { name: 'End Date', key: 'endDate', size: 2, sortKey: 'endDate', classSize: 'med' },
    { name: 'Bill Type', key: 'billType', size: 2, sortKey: 'billType', classSize: 'med' },
    { name: 'Expense Type', key: 'type', size: 2, sortKey: 'type', classSize: 'med' },
    { name: 'Division', key: 'division', size: 2, sortKey: 'division', classSize: 'med' },
];

const order =
    'Traveler Name, Ticket Number, Start Date, End Date, Bill Type, Expense Type, Division, Source';

const source = [
    'Reimbursement (Associate)',
    'Reimbursement (Clinician)',
    'Conferma',
    'Corpay',
    'Travel Inc',
];
// NCREFF = Non-Clinician Reimbursement Expense Feature Flag
const sourceNCREFF = ['Reimbursement (Associate)', 'Reimbursement (Clinician)'];

const searchKeys = [
    { name: 'Clinician Name', value: 'clinicianName' },
    { name: 'Clinician Id', value: 'clinicianId' },
    { name: 'Booking Number', value: 'bookingName' },
    { name: 'Merchant Name', value: 'merchantName' },
    { name: 'Expense Id', value: 'expenseId' },
    { name: 'Client Id', value: 'clientId' },
    { name: 'Recruiter', value: 'recruiterName' },
    { name: 'Salesperson', value: 'salespersonName' },
    // { name: 'Credit Card Account', value: 'CCAccount' }, TDS-7826: Remove Credit Card Account as a search attribute (will be added back later)
];

const vendorPaymentSearchKeys = [
    { name: 'Clinician Name', value: 'clinicianName' },
    { name: 'Clinician Id', value: 'clinicianId' },
    { name: 'Booking Number', value: 'bookingName' },
    { name: 'Expense Id', value: 'expenseId' },
    { name: 'Requested by', value: 'createdUserName' },
];

const vaultSearchKeys = [
    { name: 'Clinician Name', value: 'clinicianName' },
    { name: 'Expense Id', value: 'expenseId' },
];

// Specific search keys for Credit Card expenses
const creditCardSearchKeys = [
    { name: 'Expense Id', value: 'expenseId' },
    { name: 'Credit Card Account', value: 'creditCardAccount' },
    { name: 'Merchant Name', value: 'merchantName' },
    { name: 'Clinician Name', value: 'clinicianName' },
    { name: 'Booking Number', value: 'bookingNumber' },
    { name: 'Clinician Id', value: 'clinicianId' },
    { name: 'Client Id', value: 'clientId' },
    { name: 'Recruiter', value: 'recruiterName' },
    { name: 'Salesperson', value: 'salespersonName' },
];

const mockData = [
    {
        Clinician: 'Dr. John Doe',
        BookingNumber: 'BKG-123456',
        TransactionDate: '01-15-2023',
        PostDate: '01-20-2023',
        Division: 'Anesthesia',
        BillType: 'Billable',
        ExpenseType: 'Verification',
        Amount: '€500',
        Status: 'Submitted',
        StartDate: '01-01-2023',
        EndDate: '01-31-2023',
        Source: 'Reimbursement',
        CreditCardAccount: '1234-Card Name',
    },
    {
        Clinician: 'Dr. Jane Smith',
        BookingNumber: 'BKG-789012',
        TransactionDate: '02-10-2023',
        PostDate: '02-15-2023',
        Division: 'Anesthesia',
        BillType: 'Non-Bill Producer',
        ExpenseType: 'Application Fee',
        Amount: '£750',
        Status: 'Rejected',
        StartDate: '02-01-2023',
        EndDate: '02-28-2023',
        Source: 'Reimbursement',
        CreditCardAccount: '9876-Card Name',
    },
    {
        Clinician: 'Dr. David Brown',
        BookingNumber: 'BKG-246813',
        TransactionDate: '03-20-2023',
        PostDate: '03-25-2023',
        Division: 'Anesthesia',
        BillType: 'Billable',
        ExpenseType: 'Shipping',
        Amount: '₹300',
        Status: 'Approved',
        StartDate: '03-01-2023',
        EndDate: '03-31-2023',
        Source: 'Reimbursement',
        CreditCardAccount: '1357-Card Name',
    },
    {
        Clinician: 'Dr. Sarah Johnson',
        BookingNumber: 'BKG-369258',
        TransactionDate: '04-05-2023',
        PostDate: '04-10-2023',
        Division: 'Anesthesia',
        BillType: 'Billable',
        ExpenseType: 'Lab Fees',
        Amount: '$600',
        Status: 'Rejected',
        StartDate: '04-01-2023',
        EndDate: '04-30-2023',
        Source: 'Reimbursement',
        CreditCardAccount: '2468-Card Name',
    },
    {
        Clinician: 'Dr. Michael Wilson',
        BookingNumber: 'BKG-753951',
        TransactionDate: '05-18-2023',
        PostDate: '05-25-2023',
        Division: 'Anesthesia',
        BillType: 'Non-Bill Team',
        ExpenseType: 'Fingerprinting',
        Amount: '$900',
        Status: 'Approved',
        StartDate: '05-01-2023',
        EndDate: '05-31-2023',
        Source: 'Conferma',
        CreditCardAccount: '3698-Card Name',
    },
    {
        Clinician: 'Dr. Lisa Anderson',
        BookingNumber: 'BKG-852036',
        TransactionDate: '06-12-2023',
        PostDate: '06-20-2023',
        Division: 'Anesthesia',
        BillType: 'Non-Bill Producer',
        ExpenseType: 'Parking',
        Amount: '$1200',
        Status: 'Disputed',
        StartDate: '06-01-2023',
        EndDate: '06-30-2023',
        Source: 'Conferma',
        CreditCardAccount: '9512-Card Name',
    },
    {
        Clinician: 'Dr. Emily Thomas',
        BookingNumber: 'BKG-456789',
        TransactionDate: '07-25-2023',
        PostDate: '07-30-2023',
        Division: 'Anesthesia',
        BillType: 'Billable',
        ExpenseType: 'Auto',
        Amount: '$400',
        Status: 'New',
        StartDate: '07-01-2023',
        EndDate: '07-31-2023',
        Source: 'Conferma',
        CreditCardAccount: '3579-Card Name',
    },
    {
        Clinician: 'Dr. Robert Garcia',
        BookingNumber: 'BKG-159753',
        TransactionDate: '08-08-2023',
        PostDate: '08-15-2023',
        Division: 'Anesthesia',
        BillType: 'Non-Bill Team',
        ExpenseType: 'Compliance Fees',
        Amount: '$1500',
        Status: 'Approved',
        StartDate: '08-01-2023',
        EndDate: '08-31-2023',
        Source: 'Conferma',
        CreditCardAccount: '0246-Card Name',
    },
    {
        Clinician: 'Dr. Laura Martinez',
        BookingNumber: 'BKG-951753',
        TransactionDate: '09-30-2023',
        PostDate: '10-05-2023',
        Division: 'Anesthesia',
        BillType: 'Billable',
        ExpenseType: 'AMA',
        Amount: '$800',
        Status: 'Disputed',
        StartDate: '09-01-2023',
        EndDate: '08-31-2023',
        Source: 'Corpay',
        CreditCardAccount: '0246-Card Name',
    },
];

const states = [
    { name: 'Alabama', value: 'AL' },
    { name: 'Alaska', value: 'AK' },
    { name: 'Arizona', value: 'AZ' },
    { name: 'Arkansas', value: 'AR' },
    { name: 'California', value: 'CA' },
    { name: 'Colorado', value: 'CO' },
    { name: 'Connecticut', value: 'CT' },
    { name: 'District of Columbia', value: 'DC' },
    { name: 'Delaware', value: 'DE' },
    { name: 'Florida', value: 'FL' },
    { name: 'Georgia', value: 'GA' },
    { name: 'Hawaii', value: 'HI' },
    { name: 'Idaho', value: 'ID' },
    { name: 'Illinois', value: 'IL' },
    { name: 'Indiana', value: 'IN' },
    { name: 'Iowa', value: 'IA' },
    { name: 'Kansas', value: 'KS' },
    { name: 'Kentucky', value: 'KY' },
    { name: 'Louisiana', value: 'LA' },
    { name: 'Maine', value: 'ME' },
    { name: 'Maryland', value: 'MD' },
    { name: 'Massachusetts', value: 'MA' },
    { name: 'Michigan', value: 'MI' },
    { name: 'Minnesota', value: 'MN' },
    { name: 'Mississippi', value: 'MS' },
    { name: 'Missouri', value: 'MO' },
    { name: 'Montana', value: 'MT' },
    { name: 'Nebraska', value: 'NE' },
    { name: 'Nevada', value: 'NV' },
    { name: 'New Hampshire', value: 'NH' },
    { name: 'New Jersey', value: 'NJ' },
    { name: 'New Mexico', value: 'NM' },
    { name: 'New York', value: 'NY' },
    { name: 'North Carolina', value: 'NC' },
    { name: 'North Dakota', value: 'ND' },
    { name: 'Ohio', value: 'OH' },
    { name: 'Oklahoma', value: 'OK' },
    { name: 'Oregon', value: 'OR' },
    { name: 'Pennsylvania', value: 'PA' },
    { name: 'Rhode Island', value: 'RI' },
    { name: 'South Carolina', value: 'SC' },
    { name: 'South Dakota', value: 'SD' },
    { name: 'Tennessee', value: 'TN' },
    { name: 'Texas', value: 'TX' },
    { name: 'Utah', value: 'UT' },
    { name: 'Vermont', value: 'VT' },
    { name: 'Virginia', value: 'VA' },
    { name: 'Washington', value: 'WA' },
    { name: 'West Virginia', value: 'WV' },
    { name: 'Wisconsin', value: 'WI' },
    { name: 'Wyoming', value: 'WY' },
];

const needsReviewReasons = [
    { name: 'EXPENSE_COMMENT', value: 'Expense Comment' },
    { name: 'REQUIRES_EXPENSE_ATTACHMENT', value: 'Requires Expense Attachment' },
    { name: 'OLD_TRANSACTION_DATE', value: 'Old Transaction Date' },
    { name: 'OVER_CAP_THRESHOLD', value: 'Over Cap Threshold' },
    { name: 'EXPENSE_NOT_EXPECTED', value: 'Expense Not Expected' },
    { name: 'CONCURRENT_AIR_TRANSACTION', value: 'Concurrent Air Transaction' },
    { name: 'CONCURRENT_AUTO_TRANSACTION', value: 'Concurrent Auto Transaction' },
    { name: 'AUTO_MILEAGE_CONFLICT', value: 'Auto Mileage Conflict' },
    { name: 'CONCURRENT_LODGING_TRANSACTION', value: 'Concurrent Lodging Transaction' },
    { name: 'EXPENSE_EXCEPTION_NOTES', value: 'Expense Exception Notes' },
    { name: 'CONCURRENT_EXPENSE_TRANSACTION', value: 'Concurrent Expense Transaction' },
    { name: 'MISC_EXPENSE', value: 'Misc Expense' },
    { name: 'AUTO_BOOKING_CONFLICT', value: 'Auto Booking Conflict' },
    { name: 'AIR_BOOKING_CONFLICT', value: 'Air Booking Conflict' },
    { name: 'FUTURE_AIR_DATE', value: 'Future Air Date' },
    { name: 'LODGING_BOOKING_CONFLICT', value: 'Lodging Booking Conflict' },
    { name: 'FUTURE_LODGING_DATE', value: 'Future Lodging Date' },
    { name: 'CLINICIAN_ID_CONFLICT', value: 'Clinician ID Conflict' },
    { name: 'BOOKING_CONFLICT', value: 'Booking Conflict' },
    { name: 'OLD_START_DATE', value: 'Old Start Date' },
    { name: 'OLD_END_DATE', value: 'Old End Date' },
    { name: 'FUTURE_AUTO_DATE', value: 'Future Auto Date' },
    { name: 'REQUIRES_MILEAGE_VERIFICATION', value: 'Requires Mileage Verification' },
    { name: 'EXCESSIVE_START_DATE', value: 'Excessive Start Date' },
    { name: 'AB5', value: 'AB5' },
    { name: 'THIRD_PARTY_BOOKING', value: 'Third Party Booking' },
    { name: 'EXPENSE_STIPEND_CONFLICT', value: 'Expense Stipend Conflict' },
    { name: 'EXCESSIVE_MILEAGE', value: 'Excessive Mileage' },
    { name: 'BILL_TYPE_CONFLICT', value: 'Bill Type Conflict' },
];

export const config = {
    tableColumns,
    pendingCCTableColumns,
    hasSearch: true,
    source,
    sourceNCREFF,
    searchKeys,
    mockData,
    states,
    needsReviewReasons,
    vaultChargesTableColumns,
    vendorPaymentTableColumns,
    vendorPaymentSearchKeys,
    vaultSearchKeys,
    creditCardSearchKeys,
    creditCardTableColumns,
};

export default config;
